<div [style.height]="height()+'px'" class="background-gradient">
	@if(background()){
		<div class="legend-background">
			<img src="img/logo/white-full.png"/>		
		</div>
	}
	<div class="top"></div>
</div>